var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.08317,
    cy: 5.66667,
    r: 3.54167,
    fill: "#383538"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 7.08411L13.458 11.3341",
    stroke: "#0096FF",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 9.20911L11.333 9.20911",
    stroke: "#0096FF",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1422 14.4376C12.4692 14.3636 12.6653 14.0236 12.5204 13.7213C12.1295 12.906 11.4871 12.1896 10.6545 11.6496C9.62995 10.9852 8.3746 10.625 7.08317 10.625C5.79174 10.625 4.5364 10.9852 3.51183 11.6496C2.67922 12.1896 2.03684 12.906 1.64598 13.7213C1.50104 14.0236 1.69717 14.3636 2.02416 14.4376C5.35466 15.1919 8.81168 15.1919 12.1422 14.4376Z",
    fill: "#383538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvited);
export default __webpack_public_path__ + "static/media/invited.a1f5aeb23c4556e04351f3174108ffee.svg";
export { ForwardRef as ReactComponent };